@if(beginRender){
<div class="consolidate-card-container">
    @for(card of cardConfig; track idx; let idx = $index){
    @if(card['cardStyle'] === 'iconWithLabel'){
    <div class="icon-with-label">
        <mat-card appearance="outlined" [class]="card['class']" class="consolidate-count-card"
            [routerLink]="card['link']">
            <div class="count-value">
                <i [class]="card['icon']"></i>
            </div>
            <div class="count-label">
                @if(card['isLoading']){
                <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"
                    style="display: inline-block; vertical-align: middle;">
                </mat-progress-spinner>
                }@else{
                <app-animated-number [targetNumber]="card['label']">
                </app-animated-number>
                }
            </div>
        </mat-card>
    </div>
    }@else if(card['cardStyle'] === 'labelWithValue'){
    <div class="label-with-value">
        <mat-card appearance="outlined" class="consolidate-count-card" [class]="card['class']">
            <div class="count-label">{{card['value'] ?? '' | camelCase}}</div>
            <div class="count-value">
                @if(card['isLoading']){
                <mat-progress-spinner diameter="20" mode="indeterminate"
                    style="display: inline-block; vertical-align: middle;">
                </mat-progress-spinner>
                }@else{
                <app-animated-number [targetNumber]="card['label']">
                </app-animated-number>
                }
            </div>
        </mat-card>
    </div>
    }
    }
</div>
}